export default {
      id: "vague_titre-usage",
      viewBox: "0 0 155 10",
      url: "../dist/images/" + "sprite.svg#vague_titre-usage",
      toString: function () {
        return this.url;
      }
    }